import React from "react";
import { MessageCircle } from "lucide-react";
import { useConfig } from "@/context/ConfigContext";

export default function WhatsAppFloat() {
  const { whatsapp_number } = useConfig();
  const num = (whatsapp_number || "34613807514").replace(/\D/g, "");
  return (
    <a
      href={`https://wa.me/${num}?text=Hola%20pillauncoche!%20Quer%C3%ADa%20info...`}
      target="_blank" rel="noreferrer"
      className="wa-float"
      data-testid="whatsapp-float"
      aria-label="WhatsApp"
    >
      <MessageCircle size={28} />
    </a>
  );
}
